import { apiClient } from "../../../app/api/client";
import type { ApiSuccessResponse } from "./api-response";

export interface SearchResult {
	type: "user" | "building" | "device";
	id: string;
	title: string;
	subtitle: string | null;
}

function isSearchResultType(value: unknown): value is SearchResult["type"] {
	return value === "user" || value === "building" || value === "device";
}

export function normalizeSearchResults(value: unknown): SearchResult[] {
	if (!Array.isArray(value)) {
		return [];
	}

	return value.flatMap((item) => {
		if (!item || typeof item !== "object") {
			return [];
		}

		const candidate = item as Record<string, unknown>;
		if (
			!isSearchResultType(candidate.type) ||
			typeof candidate.id !== "string" ||
			typeof candidate.title !== "string"
		) {
			return [];
		}

		return [
			{
				type: candidate.type,
				id: candidate.id,
				title: candidate.title,
				subtitle: typeof candidate.subtitle === "string" ? candidate.subtitle : null,
			},
		];
	});
}

export function getSearchResultHref(result: SearchResult): string {
	if (result.type === "user") {
		return `/users/${result.id}`;
	}

	if (result.type === "building") {
		return `/buildings/${result.id}`;
	}

	return "/devices";
}

export async function searchGlobal(query: string): Promise<SearchResult[]> {
	const trimmed = query.trim();
	if (!trimmed) {
		return [];
	}

	const response = await apiClient.get<ApiSuccessResponse<SearchResult[]>>("/search", {
		params: { q: trimmed },
	});

	return normalizeSearchResults(response.data.data);
}
